import {jam} from "@jam.dev/sdk";

const isSimpleValue = (value) => ["string", "number", "boolean"].includes(typeof value);

const compactRouteParams = (params = {}) => {
  return Object.entries(params).reduce((metadata, [key, value]) => {
    if (isSimpleValue(value)) {
      metadata[key] = value;
    }

    return metadata;
  }, {});
};

const removeEmptyValues = (metadata) => {
  return Object.entries(metadata).reduce((filtered, [key, value]) => {
    if (value === undefined || value === null || value === "") return filtered;
    if (typeof value === "object" && !Array.isArray(value) && !Object.keys(value).length) return filtered;

    filtered[key] = value;

    return filtered;
  }, {});
};

export const buildJamMetadata = (accountStore, route = {}, location = window.location) => {
  const user = accountStore?.user;
  const activeCompany = user?.activeCompany;
  const routeParams = compactRouteParams(route?.params);

  return removeEmptyValues({
    userId: user?.id,
    activeCompanyId: activeCompany?.id,
    activeCompanyName: activeCompany?.name,
    activeCompanyRole: activeCompany?.role,
    activeTeamMemberId: activeCompany?.teamMemberId,
    routeName: route?.name,
    routePath: route?.path,
    routeParams,
    hostname: location?.hostname,
  });
};

export const setupJamMetadata = (accountStore, router) => {
  jam.metadata(() => buildJamMetadata(accountStore, router?.currentRoute?.value));
};
